export const API_BASE_URL = 'api/';

export const IMG_URL: string = "assets/img/";

export const IMG_DEFAULT = `${IMG_URL}common/no-image.jpeg`;

export const LOGO: string = `${IMG_URL}common/logo.png`;

export const ICON: string = `${IMG_URL}common/logo-icon.png`;

export const ITEMS_PER_PAGE = 10;

export const ITEMS_PER_PAGE_FOR_LIST = 0;

export const MULTISELECT_LIMIT = 1000;

export const RULER = `${IMG_URL}common/ruler.png`;

export const LANG_ICON = {
  en: `${IMG_URL}common/icon-eng.png`,
  vi: `${IMG_URL}common/icon-vi.png`,
  fr: `${IMG_URL}common/fr.png`
};

export const HTTP_METHOD = {
  GET: 'GET',
  POST: 'POST',
  PATCH: 'PATCH',
  PUT: 'PUT',
  DELETE: 'DELETE',
  HEAD: 'HEAD',
}

export const SIDEBAR = {
  admin: [
    {
      title: 'Account',
      routerLink: '/admin/account',
      routerLinkActiveOption: true,
      imagePath: 'fa fa-user-secret',
      addNew: true,
      key: true,
    },
    {
      title: 'Reporting',
      routerLink: '/admin/reporting',
      routerLinkActiveOption: true,
      imagePath: 'fa fa-file-excel-o',
      addNew: true,
      key: true,
    },
    {
      title: 'Setting',
      routerLink: '/',
      routerLinkActiveOption: true,
      imagePath: 'fa fa-cog',
      addNew: true,
      key: true,
      options: [
        {
          title: 'Email Support',
          routerLink: '/admin/setting/email',
          addNew: true,
          routerLinkActiveOption: false,
          imagePath: 'fa fa-envelope-o',
        },
      ]
    }
  ],
  user: [],
};

export const LOOPBACK_PREFIX = '$LoopBack$';

export const LOCAL_STORAGE_VARIABLES = {
  USER_ID: LOOPBACK_PREFIX + 'currentUserId',
  ACCESS_TOKEN: LOOPBACK_PREFIX + 'accessTokenId',
  USER_DATA: LOOPBACK_PREFIX + 'currentUserData',
  REMEMBER_ME: LOOPBACK_PREFIX + 'rememberMe',
};

export const REGEX = {
  NUMBER : /^[+-]?([0-9]*[.])?[0-9]+$/
};

export const ACTION_MULTIPLE_CONTENT_LANG =
  {
    EDIT: 'editMultiple',
    ADD: 'addMultiple'
  }
;

export const MGA_UPLOAD = {
  CONTAINER: {
    IMAGE: 'images',
    VIDEO: 'videos',
    AUDIO: 'audios',
  },
  ACCEPT_FILE_EXTENSION: {
    IMAGE: '.jpg, .png, .jpeg, .gif, .bmp',
    VIDEO: '.mp4',
    AUDIO: 'audio/*',
    DEFAULT: '*'
  }
};

export const UPLOAD_DISPLAY_TEXT = {
  DOCUMENT: 'Add new document',
  IMAGE: 'Add new photo',
  AUDIO: 'Add new audio'
};
// --------------------------------------------------------
// Routes
export const ROUTE = {
  ADMIN: '/admin',
  USER: '/',
  LOGIN: '/login'
}
// -------------------------------------------------------

export const CONTENT_STATUS = [
  {
    active: true
  },
  {
    active: false
  }
];

export const DATE_FORMAT_DISPLAY = 'dd/MM/yyyy';
export const DATE_FORMAT_TYPE = 'yyyy-MM-dd';

// Filter
export const UNION_TYPE = {
  AND: 'and',
  OR: 'or'
};
export const OPERATOR = {
  EQUAL: 'eq',
  GREATER: 'gt',
  GREATER_EQUAL: 'gte',
  LESSER: 'lt',
  LESSER_EQUAL: 'lte',
  BETWEEN: 'between',
  IN: 'inq',
  NOT_IN: 'nin',
  NEAR: 'near',
  NOT_EQUAL: 'neq',
  LIKE: 'like',
  NOT_LIKE: 'nlike',
  REGEX: 'regexp' // new RegExp(/John/)
};
//---------------------------------------------------

// -------------------------------------------------------
// Staff
export const STAFF_TYPE = {
  USER: 1,
  ADMIN: 2
};
export const STAFF_TYPES = [
  {id: STAFF_TYPE.USER, label: 'User'},
  {id: STAFF_TYPE.ADMIN, label: 'Admin'},
];

// -------------------------------------------------------
// Sweetalert2
export const SWAL_COMMMON = {
  UPDATE_SUCCESS: {
    title: 'Successfully!',
    text: 'Update successfully',
    type: 'success',
  },
  CREATE_SUCCESS: {
    title: 'Successfully!',
    text: 'Create successfully',
    type: 'success'
  },
  DELETE_SUCCESS: {
    title: 'Successfully!',
    text: 'Delete successfully',
    type: 'success'
  },
  DELETE_WARNING: {
    title: 'Warning',
    text: 'Are you sure you want to proceed with the deletion?',
    type: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#DD6B55',
    confirmButtonText: 'Yes',
    cancelButtonText: 'No',
    allowOutsideClick: false
  },
  RESET_WARNING: {
    title: 'Warning',
    text: 'This action will reset the “Used Query” and can\'t be undone. Do you want to proceed?',
    type: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#DD6B55',
    confirmButtonText: 'Yes',
    cancelButtonText: 'No',
    allowOutsideClick: false
  },
  RESET_SUCCESS: {
    title: 'Successfully!',
    text: 'Reset successfully',
    type: 'success'
  }
};
export const SWAL_UPLOAD = {
  FILE_TYPE_WARNING: {
    title: 'Warning',
    text: 'Please choose the correct file extension!',
    type: 'warning'
  },
  VIDEO_EXTENSION_WARNING: {
    title: 'Warning',
    text: 'Please choose the correct MP4 file extension!',
    type: 'warning'
  },
  IMAGE_EXTENSION_WARNING: {
    title: 'Warning',
    text: 'Please choose the correct image file extension!',
    type: 'warning'
  },
  AUDIO_EXTENSION_WARNING: {
    title: 'Warning',
    text: 'Please choose the correct MP3 file extension!',
    type: 'warning'
  },
  DELETE_WARNING: {
    title: 'Warning',
    text: 'Are you sure you want to delete this file?',
    type: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#DD6B55',
    confirmButtonText: 'Yes',
    cancelButtonText: 'No',
    allowOutsideClick: false
  },
  WARNING_MAX_SIZE: {
    title: 'Warning',
    text: 'File uploading is larger than 100MB!',
    type: 'warning'
  },
  WARNING_IMG_DIMENSION: {
    title: 'Warning Image',
    text: 'Height and Width must not exceed 1024px.',
    type: 'warning'
  },
  WARNING_BROWSER_HTML5: {
    title: 'Warning',
    text: 'This browser does not support HTML5.',
    type: 'warning'
  },
  WARNING_MULTIPLE_FILES: {
    title: 'Warning',
    text: 'Please drag and drop single file selection!',
    type: 'warning'
  },
};
export const SWAL_API_FIND = {
  NOITEM_WARNING: {
    title: 'Searching',
    text: 'No item found!. Please try again.',
  }
};
export class SwalErrorHandler {
  static errorMessage(error) {
    return {title: 'Error!', text: error, type: 'error'};
  }
  static successMessage(success, param?: any) {
    return {title: 'Successfully!', text: success + param, type: 'success'};
  }
  static warningMessage(warning) {
    return {title: 'Warning!', text: warning, type: 'warning'};
  }
}

export class SwalResponseHandler {
  static message(title, message, type = 'success') {
    return {title: title, text: message, type: type};
  }
}
//---------------------------------------------------------------------
export const PAGE_ACTION = {
  CREATE: 'create',
  EDIT: 'edit'

}

export const DEFAULT_PASSWORD = 'default';

export const VALIDATOR_PATERN = {
  DOMAIN: /^[a-zA-Z0-9._-]+[.]+[a-zA-Z]+$/
}

export const WIDGET_SETTING_CODE = 'widget-email-template';


// WEBPACK FOOTER //
// ./src/app/shared/constants.ts